export const team = {
  title: "Teams",
  label: {
    emptyTitle: "No teams yet",
    emptyDescription: "Add the first team",
    deleteToastSucces: (teamName: string) => `Successfully deleted team ${teamName}`
  }
}